import { isBanamexTenant } from "../config/features/banamex";

/**
 * Catalogo de politicas internas que se registran en la evaluacion del caso.
 *
 * Es global (no del tenant), como RC-100: vive en `custom_catalogue`. El
 * sembrado de djaguar (utils/collections/Policies.py) es de DEMO; cada cliente
 * lo sustituye por sus politicas reales desde el configurador, sin que esto
 * cambie.
 */
const POLICIES_CATALOGUE = {
  code: "PL-100",
  isOwn: false,
};

/**
 * Banamex usa sus politicas reales, las del catalogo propio `policyViolated`.
 * Solo existe en sus tenants: en cualquier otro el backend responde 400.
 */
const BANAMEX_POLICIES_CATALOGUE = {
  code: "policyViolated",
  isOwn: true,
};

export const getPoliciesCatalogue = () =>
  isBanamexTenant() ? BANAMEX_POLICIES_CATALOGUE : POLICIES_CATALOGUE;
